import React from 'react'
import { Button, Segment, SegmentGroup } from 'semantic-ui-react'
import CopyInput from 'shared/components/CopyInput'

export default function ApiKeyCreatedModal({ modal: Modal, apiKey, onClose }) {
  return (
    <Modal size="tiny" closeOnDimmerClick={false} closeOnEscape={false}>
      <Modal.Header>Save your API key</Modal.Header>
      <Modal.Content>
        <SegmentGroup>
          <Segment>
            <div className="flex gap-3 items-baseline">
              <i className="far fa-exclamation-triangle text-orange" />
              <div>
                <strong>You'll only see this key once.</strong>
                <p>Copy and store it securely. We cannot recover it if you lose it.</p>
              </div>
            </div>
          </Segment>
          <Segment>
            <CopyInput value={apiKey} />
          </Segment>
        </SegmentGroup>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>Close</Button>
      </Modal.Actions>
    </Modal>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/ApiKey/ApiKeyCopyModal.js